import {useEffect, useState} from "react";
import {PostJSON} from "../components/api/webservice";
import {Apis} from "../components/api/url";
import {HomeHeader} from "../components/home/home-header";
import {Outlet} from "react-router-dom";
import {HomeFooter} from "../components/home/home-footer";
import {HideMainLoading} from "../components/template/architecture";

export const HomeArchitecture = () => {
    const [presignup, setPresignup] = useState(false);
    const fetchPresignupEnabled = () => {
        PostJSON(
            Apis.server + '/core/home/pres-status',
            {},
            false,
            (d: {
                result: string,
                reason: string,
                enable: boolean,
            }) => {
                if (d.result !== 'OK')
                    return;
                setPresignup(d.enable);
                HideMainLoading();
            },
            () => {
            },
            () => {
            },
        ).then(void 0);
    };
    useEffect(() => {
        fetchPresignupEnabled();
    }, []);
    return (
        <>
            <HomeHeader signup={presignup}/>
            <Outlet/>
            <HomeFooter signup={presignup}/>
        </>
    );
};